import type {
  LoyaltyMemberDetails,
  SelectedLoyaltyVoucher,
} from '@maestro/data-layer'

import { apiGet } from '@maestro/core/api-client'

export function getAppliedLoyaltyVouchers(
  cartId: string
): Promise<SelectedLoyaltyVoucher[]> {
  return apiGet<SelectedLoyaltyVoucher[]>(
    `/api/loyalty/vouchers/${encodeURIComponent(cartId)}`
  )
}

export function getMemberDetails(): Promise<LoyaltyMemberDetails> {
  return apiGet<LoyaltyMemberDetails>('/api/loyalty/member')
}
